// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.calendar-installation {
  margin-top: 25px;
  display: flex;
  justify-content: center;
}
.calendar-installation__tooltip {
  margin-top: 15px;
}
.calendar-installation__tooltip-items {
  display: flex;
  margin-bottom: 7px;
}
.calendar-installation__tooltip-items__planning {
  margin-top: 5px;
  width: 15px;
  height: 15px;
  background-color: #42aaff;
}
@media (max-width: 450px) {
  .calendar-installation__tooltip-items__planning {
    width: 13px;
    height: 13px;
  }
}
.calendar-installation__tooltip-items__materials {
  margin-top: 5px;
  width: 15px;
  height: 15px;
  background-color: #008000;
}
@media (max-width: 450px) {
  .calendar-installation__tooltip-items__materials {
    width: 13px;
    height: 13px;
  }
}
.calendar-installation__tooltip-items__installation {
  margin-top: 5px;
  width: 15px;
  height: 15px;
  background-color: #ffc0cb;
}
@media (max-width: 450px) {
  .calendar-installation__tooltip-items__installation {
    width: 13px;
    height: 13px;
  }
}
.calendar-installation__tooltip-items__brigade {
  font-size: 17px;
  font-weight: 500;
}
@media (max-width: 450px) {
  .calendar-installation__tooltip-items__brigade {
    font-size: 15px;
  }
}
.calendar-installation__tooltip-items__description {
  margin-left: 7px;
  font-size: 17px;
  font-weight: 500;
}
@media (max-width: 450px) {
  .calendar-installation__tooltip-items__description {
    font-size: 15px;
  }
}

.react-calendar__tile {
  height: auto !important;
}`, "",{"version":3,"sources":["webpack://./src/components/InstallationPage/CalendarInstallation/style.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,aAAA;EACA,uBAAA;AACJ;AACI;EACI,gBAAA;AACR;AACQ;EACI,aAAA;EACA,kBAAA;AACZ;AAEY;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;AAAhB;AACgB;EALJ;IAMQ,WAAA;IACA,YAAA;EAElB;AACF;AACY;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;AAChB;AAAgB;EALJ;IAMQ,WAAA;IACA,YAAA;EAGlB;AACF;AAAY;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;AAEhB;AADgB;EALJ;IAMQ,WAAA;IACA,YAAA;EAIlB;AACF;AADY;EACI,eAAA;EACA,gBAAA;AAGhB;AAFgB;EAHJ;IAIQ,eAAA;EAKlB;AACF;AAFY;EACI,gBAAA;EACA,eAAA;EACA,gBAAA;AAIhB;AAHgB;EAJJ;IAKQ,eAAA;EAMlB;AACF;;AAAA;EACI,uBAAA;AAGJ","sourcesContent":[".calendar-installation {\n    margin-top: 25px;\n    display: flex;\n    justify-content: center;\n\n    &__tooltip {\n        margin-top: 15px;\n\n        &-items {\n            display: flex;\n            margin-bottom: 7px;\n            \n\n            &__planning {\n                margin-top: 5px;\n                width: 15px;\n                height: 15px;\n                background-color: #42aaff;\n                @media(max-width: 450px) {\n                    width: 13px;\n                    height: 13px;\n                }\n            }\n\n            &__materials {\n                margin-top: 5px;\n                width: 15px;\n                height: 15px;\n                background-color: #008000;\n                @media(max-width: 450px) {\n                    width: 13px;\n                    height: 13px;\n                }\n            }\n\n            &__installation {\n                margin-top: 5px;\n                width: 15px;\n                height: 15px;\n                background-color: #ffc0cb;\n                @media(max-width: 450px) {\n                    width: 13px;\n                    height: 13px;\n                }\n            }\n\n            &__brigade {\n                font-size: 17px;\n                font-weight: 500;\n                @media(max-width: 450px) {\n                    font-size: 15px;\n                }\n            }\n\n            &__description {\n                margin-left: 7px;\n                font-size: 17px;\n                font-weight: 500;\n                @media(max-width: 450px) {\n                    font-size: 15px;\n                }\n            }\n        }\n    }\n}\n\n.react-calendar__tile {\n    height: auto !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
